export default __webpack_public_path__ + "static/media/BG-1-col.464b6456.png";